import { useCallback, useEffect } from "react";
import { StyledColorPicker } from "./styled";

export default function CustomizedColorInput({
  color = null,
  open = false,
  closeHandler = () => {},
  setColor = () => {},
}: any) {
  const handleOnScroll = useCallback(() => {
    if (open) {
      closeHandler();
    }
  }, [closeHandler, open]);

  useEffect(() => {
    const parentElementId = "create-form-content-parent";
    const parentElement = document.getElementById(parentElementId);

    parentElement && parentElement.addEventListener("wheel", handleOnScroll);

    return () => {
      parentElement &&
        parentElement.removeEventListener("wheel", handleOnScroll);
    };
  }, [handleOnScroll]);

  return (
    <StyledColorPicker
      size="small"
      trigger="click"
      open={open}
      onOpenChange={closeHandler}
      value={color}
      onChange={(value: any) => {
        setColor(value.toHexString());
      }}
    />
  );
}
